import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleProjectCreation(
  state: State,
  { zone, project }: Boundaries["createProject"]["success"],
): State {
  return {
    ...state,
    projects: [...state.projects, { ...project, zone }],
  };
}

export { handleProjectCreation };
